/**
 * Display formats of the workbook's cells. Excel shows zero as "-" and negatives in
 * parentheses ($#,##0;($#,##0);-), and so do these.
 */

const DASH = '-';

function fixed(value, decimals) {
    return Math.abs(value).toLocaleString('en-US', {minimumFractionDigits: decimals, maximumFractionDigits: decimals});
}

function signed(value, decimals, prefix = '', suffix = '') {
    if (!value || !isFinite(value)) return DASH;
    // Values that round to zero at this precision show as zero, not "-0" or "($0)".
    if (Number(value.toFixed(decimals)) === 0) return DASH;
    const body = `${prefix}${fixed(value, decimals)}${suffix}`;
    return value < 0 ? `(${body})` : body;
}

/** $1,234 / ($1,234) / - */
export const money = value => signed(value, 0, '$');

/** $1,234.56 */
export const money2 = value => signed(value, 2, '$');

/** 1,234 */
export const count = value => signed(value, 0);

/** A decimal rate as a percentage: 0.066 -> 6.60% */
export const percent = (value, decimals = 2) => signed(value * 100, decimals, '', '%');

/** 1.25x */
export const multiple = value => signed(value, 2, '', 'x');

/** 1,234 SF */
export const squareFeet = value => (value ? `${fixed(value, 0)} SF` : DASH);

/** $123.45 PSF */
export const pricePsf = value => (value ? `$${fixed(value, 2)} PSF` : DASH);

/** A rate quoted inside a label, as the workbook's TEXT(x, "0.0%"): 0 shows as 0.0%. */
export const rateLabel = value => `${((isFinite(value) ? value : 0) * 100).toFixed(1)}%`;
